<template>
  <section>
    <Title v-if="isInfoFlightPage" :title-name="titleInFoFlight.titleName" :title-link="titleInFoFlight.titleLink" />
    <Title v-else :title-name="title.Privacy.titleName" :title-link="title.Privacy.titleLink" />
    <div class="container" style="margin-top: 14pt">
      <div v-if="airline.footerConfig && airline.footerConfig.privacy">
        <p style="white-space: pre-line">{{ airline.footerConfig.privacy }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import Title from '@/components/Title'
export default {
  name: 'Privacy',
  components: {
    Title
  },
  props: {
    secret: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      titleInFoFlight: {
        titleName: 'Info Flight Update',
        titleLink: 'InfoFlightUpdate'
      }
    }
  },
  watch: {
    title: function () {
      this.initData()
    },
    airline: function () {
      this.checkRedirect()
    }
  },
  beforeCreate() {
    this.$emit('changeLinkName', '')
  },
  created() {
    if (!_.isEmpty(this.airline)) {
      this.checkRedirect()
    }
    if (!_.isEmpty(this.title)) {
      this.initData()
    }
  },
  methods: {
    initData: function () {
      let isNotEmptyTitle = _.every(this.title, function (title) {
        return _.size(title) > 0
      })
      if (!_.isUndefined(this.token) && isNotEmptyTitle) {
        this.title.Privacy.titleName = 'Virtual support desk'
        this.title.Privacy.titleLink = 'VirtualHelpdesk'
        this.$store.dispatch('VirtualHelpdesk/getLanguagesByAirlineToken', {
          airline_token: this.$route.query.token,
          lang_code: 'en'
        })
      }
    },
    checkRedirect: function () {
      if (!this.airline.template_config || !this.airline.template_config.privacy_enable) {
        window.location.href = '/home?secret=' + this.secret
      }
    }
  }
}
</script>
